import React from 'react';
import { useTranslation } from 'react-i18next';
import DashboardCardIcon from '../../assets/icons/DashboardCardIcon';
import DashboardListIcon from '../../assets/icons/DashboardListIcon';
import styles from './ProjectListHeader.module.scss';

export type ViewType = 'card' | 'list';

interface ProjectListHeaderProps {
  currentView?: ViewType;
  onViewChange?: (view: ViewType) => void;
}

const ProjectListHeader: React.FC<ProjectListHeaderProps> = ({ currentView = 'list', onViewChange }) => {
  const { t } = useTranslation('project');
  const handleViewChange = (view: ViewType) => {
    onViewChange?.(view);
  };

  return (
    <div className={styles.projectListHeader}>
      <h2 className={styles.title}>{t('list.title')}</h2>
      <div className={styles.viewToggleContainer}>
        <button
          className={`${styles.viewToggleButton} ${currentView === 'list' ? styles.active : ''}`}
          onClick={() => handleViewChange('list')}
          aria-label={t('list.viewList')}>
          <span className={styles.iconWrapper}>
            <DashboardListIcon />
          </span>
        </button>
        <button
          className={`${styles.viewToggleButton} ${currentView === 'card' ? styles.active : ''}`}
          onClick={() => handleViewChange('card')}
          aria-label={t('list.viewCard')}>
          <span className={styles.iconWrapper}>
            <DashboardCardIcon />
          </span>
        </button>
      </div>
    </div>
  );
};

export default ProjectListHeader; 